export const getSpec = (apiClient) => {
    return {
        async build(items, showPrices = true, stockPick = 'shortest') {
            return apiClient.request('/calculator/spec', { items, showPrices, stockPick });
        },
    };
};
